import { useState } from "react";
import { T } from "./exports";
import { IB, Lbl } from "./UIHelper";
import { KIOSK_ICON_NAMES, KioskIcon } from "../Widgets/KioskIcon";

export function IconPicker({ label, value, onChange }) {
  const [open, setOpen] = useState(false);
  const [q, setQ] = useState("");
  const isLucide = KIOSK_ICON_NAMES.includes(value);
  const names = KIOSK_ICON_NAMES.filter(n => n.toLowerCase().includes(q.trim().toLowerCase()));
  return <div style={{ marginBottom: 5 }}>
    {label && <Lbl ch={label} />}
    <div style={{ display: "flex", gap: 3, alignItems: "center" }}>
      <button onClick={() => setOpen(o => !o)} style={{ width: 28, height: 24, flexShrink: 0, background: T.bgInput, border: `1px solid ${open ? T.blue : T.border}`, borderRadius: 3, color: T.text, cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", padding: 0 }}>
        {value ? <KioskIcon name={value} size={14} color={T.text} /> : <span style={{ fontSize: 9, color: T.textMute }}>—</span>}
      </button>
      <input value={value || ""} onChange={e => onChange(e.target.value)} placeholder="Icon name or emoji" style={{ ...IB, flex: 1 }} />
      {value && <button onClick={() => onChange("")} style={{ background: "none", border: "none", color: T.textMute, cursor: "pointer", fontSize: 10, padding: 0 }}>✕</button>}
    </div>
    {value && !isLucide && <div style={{ fontSize: 8, color: T.textMute, marginTop: 2 }}>Shown as text. Pick from the grid for a Lucide icon.</div>}
    {open && <div style={{ background: T.bg, border: `1px solid ${T.border}`, borderRadius: 4, padding: 5, marginTop: 4 }}>
      <input value={q} onChange={e => setQ(e.target.value)} placeholder="Search icons…" style={{ ...IB, marginBottom: 5 }} />
      <div style={{ display: "grid", gridTemplateColumns: "repeat(8, 1fr)", gap: 3, maxHeight: 150, overflowY: "auto" }}>
        {names.map(n => (
          <button key={n} title={n} onClick={() => { onChange(n); setOpen(false); }} style={{ height: 24, background: value === n ? T.accent : T.bgCard, border: `1px solid ${value === n ? T.blue : T.border}`, borderRadius: 3, cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", padding: 0 }}>
            <KioskIcon name={n} size={13} color={T.text} />
          </button>
        ))}
      </div>
    </div>}
  </div>;
}
